import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merges class names, resolving conflicting Tailwind utilities in favour of the last one.
 * Prefer this over `clsx` alone, which keeps both and leaves the winner up to CSS source order.
 *
 * @example
 * cn('p-2', 'p-4') // 'p-4'
 * cn('text-primary', isActive && 'text-foreground')
 */
export const cn = (...inputs: ClassValue[]) => {
  return twMerge(clsx(inputs));
};
